import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ClockCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/ClockCircleOutlined";
import AntdIcon from "../components/AntdIcon";
var ClockCircleOutlined = function ClockCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ClockCircleOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(ClockCircleOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'ClockCircleOutlined';
}
export default RefIcon;